var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._t(
        "default",
        function() {
          return [
            _c(
              "div",
              { staticClass: "container" },
              [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-12" }, [
                    _c(
                      "h1",
                      {
                        staticClass: "product-detail__title",
                        attrs: { "data-testing": "item-name" }
                      },
                      [
                        _vm._v(
                          "\n                      " +
                            _vm._s(_vm._f("itemName")(_vm.currentVariation)) +
                            "\n                    "
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-12 col-md-6 col-lg-7" },
                    [_c("client-only", [_vm._t("image-carousel")], 2)],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-12 col-md-6 col-lg-4" }, [
                    _c(
                      "div",
                      { staticClass: "product-detail" },
                      [
                        _vm._t("tag-list"),
                        _vm._v(" "),
                        _vm._t("before-price"),
                        _vm._v(" "),
                        _vm.currentVariation.filter.isSalable &&
                        _vm.variationGroupedProperties.length
                          ? _c(
                              "div",
                              { staticClass: "product-detail__property-list" },
                              [_c("order-property-list")],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("item-price", {
                          attrs: {
                            "show-cross-price": _vm.isRecommendedPriceActive,
                            "show-net-price": _vm.showNetPrices
                          }
                        }),
                        _vm._v(" "),
                        _vm._t("after-price"),
                        _vm._v(" "),
                        _vm._t("additional-content-after-vat"),
                        _vm._v(" "),
                        _c("item-availability", {
                          staticClass: "product-detail__availability"
                        }),
                        _vm._v(" "),
                        _vm.attributes.length || Object.keys(_vm.units).length
                          ? _c(
                              "div",
                              { staticClass: "product-detail__variation" },
                              [_c("variation-select")],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isShortDescriptionActive &&
                        _vm.currentVariation.texts.shortDescription !== ""
                          ? _c("p", {
                              staticClass: "product-detail__short-description",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.currentVariation.texts.shortDescription
                                )
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "product-detail__bundle" },
                          [
                            _vm.currentVariation.variation.bundleType ===
                            "bundle"
                              ? _c("item-bundle", {
                                  attrs: {
                                    "bundle-type":
                                      _vm.currentVariation.variation.bundleType,
                                    "bundle-components":
                                      _vm.currentVariation.bundleComponents
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm._t("before-add-to-basket"),
                        _vm._v(" "),
                        _vm.currentVariation.item.itemType === "set"
                          ? _c(
                              "div",
                              { staticClass: "alert alert-info w-100" },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _vm.$translate(
                                        "Ceres::Template.singleItemSetInfo"
                                      )
                                    ) +
                                    "\n                            "
                                )
                              ]
                            )
                          : _c(
                              "div",
                              {
                                staticClass:
                                  "product-detail__add-to-basket form-row align-items-center"
                              },
                              [
                                _c("add-to-basket", {
                                  staticClass: "col",
                                  attrs: {
                                    "variation-id":
                                      _vm.currentVariation.variation.id,
                                    "is-salable":
                                      !!_vm.currentVariation.filter &&
                                      _vm.currentVariation.filter.isSalable,
                                    "has-children":
                                      !!_vm.currentVariation.filter &&
                                      _vm.currentVariation.filter
                                        .hasActiveChildren,
                                    "interval-quantity":
                                      _vm.currentVariation.variation
                                        .intervalOrderQuantity || 1,
                                    "minimum-quantity":
                                      _vm.currentVariation.variation
                                        .minimumOrderQuantity,
                                    "maximum-quantity":
                                      !!_vm.currentVariation.variation
                                        .maximumOrderQuantity &&
                                      _vm.currentVariation.variation
                                        .maximumOrderQuantity > 0
                                        ? _vm.currentVariation.variation
                                            .maximumOrderQuantity
                                        : null,
                                    "order-properties": _vm.currentVariation.properties.filter(
                                      function(prop) {
                                        return prop.property.isOderProperty
                                      }
                                    ),
                                    "use-large-scale": false,
                                    "show-quantity": true,
                                    "item-url": _vm._f("itemURL")(
                                      _vm.currentVariation
                                    ),
                                    "is-variation-selected":
                                      _vm.isVariationSelected &&
                                      _vm.currentVariation.filter.isSalable,
                                    "has-price": _vm._f("hasItemDefaultPrice")(
                                      _vm.currentVariation
                                    )
                                  }
                                })
                              ],
                              1
                            ),
                        _vm._v(" "),
                        _vm._t("after-add-to-basket"),
                        _vm._v(" "),
                        _vm._t("additional-content-after-add-to-basket"),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "row mt-5 product-detail__id-wrapper"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex align-items-center justify-content-between w-100"
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "product-detail__id" },
                                  [
                                    _c("b", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$translate(
                                            "Ceres::Template.singleItemNumber"
                                          )
                                        ) + ":"
                                      )
                                    ]),
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(
                                          _vm.currentVariation.variation.number
                                        ) +
                                        "\n                                    "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "product-detail-wishlist" },
                                  [
                                    _c("add-to-wish-list", {
                                      attrs: {
                                        "variation-id":
                                          _vm.currentVariation.variation.id
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            )
                          ]
                        )
                      ],
                      2
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-12" }, [
                    _c("div", { staticClass: "product-detail-tabs" }, [
                      _c(
                        "ul",
                        {
                          staticClass: "nav nav-tabs",
                          attrs: { role: "tablist" }
                        },
                        [
                          _vm.isDescriptionTabActive
                            ? _c("li", { staticClass: "nav-item" }, [
                                _c(
                                  "a",
                                  {
                                    staticClass: "nav-link active",
                                    attrs: {
                                      "data-toggle": "tab",
                                      href:
                                        "#details-" +
                                        _vm.currentVariation.variation.id,
                                      role: "tab"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$translate(
                                          "Ceres::Template.singleItemDescription"
                                        )
                                      )
                                    )
                                  ]
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isTechnicalDataTabActive
                            ? _c("li", { staticClass: "nav-item" }, [
                                _c(
                                  "a",
                                  {
                                    staticClass: "nav-link",
                                    class: {
                                      active:
                                        !_vm.isDescriptionTabActive &&
                                        _vm.isTechnicalDataTabActive
                                    },
                                    attrs: {
                                      "data-toggle": "tab",
                                      href:
                                        "#data-" +
                                        _vm.currentVariation.variation.id,
                                      role: "tab"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$translate(
                                          "Ceres::Template.singleItemTechnicalData"
                                        )
                                      )
                                    )
                                  ]
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("li", { staticClass: "nav-item" }, [
                            _c(
                              "a",
                              {
                                staticClass: "nav-link",
                                class: {
                                  active:
                                    !_vm.isDescriptionTabActive &&
                                    !_vm.isTechnicalDataTabActive
                                },
                                attrs: {
                                  "data-toggle": "tab",
                                  href: "#assessments-details",
                                  role: "tab"
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$translate(
                                      "Ceres::Template.singleItemMoreDetails"
                                    )
                                  )
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _vm._t("add-detail-tabs")
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "tab-content overflow-hidden" },
                        [
                          _vm.isDescriptionTabActive
                            ? _c(
                                "div",
                                {
                                  staticClass: "tab-pane active overflow-auto",
                                  attrs: {
                                    id:
                                      "details-" +
                                      _vm.currentVariation.variation.id,
                                    role: "tabpanel"
                                  }
                                },
                                [
                                  _c("div", { staticClass: "row" }, [
                                    _c("div", { staticClass: "col-md-7" }, [
                                      _c("div", {
                                        staticClass: "my-4",
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.currentVariation.texts
                                              .description
                                          )
                                        }
                                      })
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "offset-md-1 col-md-3" },
                                      [
                                        _vm.isShortDescriptionActive &&
                                        _vm.currentVariation.texts
                                          .shortDescription !== ""
                                          ? _c("p", {
                                              staticClass:
                                                "product-detail__short-description",
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.currentVariation.texts
                                                    .shortDescription
                                                )
                                              }
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "more-infos" },
                                          [
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$translate(
                                                    "ODKahu::Template.moreInfosHeadline"
                                                  )
                                                )
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "svg",
                                              {
                                                staticClass:
                                                  "bi bi-chevron-right",
                                                attrs: {
                                                  xmlns:
                                                    "http://www.w3.org/2000/svg",
                                                  width: "16",
                                                  height: "16",
                                                  fill: "currentColor",
                                                  viewBox: "0 0 16 16"
                                                }
                                              },
                                              [
                                                _c("path", {
                                                  attrs: {
                                                    "fill-rule": "evenodd",
                                                    d:
                                                      "M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
                                                  }
                                                })
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "a",
                                              { attrs: { href: "/contact" } },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$translate(
                                                      "ODKahu::Template.moreInfosQuestion"
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ])
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isTechnicalDataTabActive
                            ? _c(
                                "div",
                                {
                                  staticClass: "tab-pane overflow-auto",
                                  class: {
                                    active:
                                      !_vm.isDescriptionTabActive &&
                                      _vm.isTechnicalDataTabActive
                                  },
                                  attrs: {
                                    id:
                                      "data-" +
                                      _vm.currentVariation.variation.id,
                                    role: "tabpanel"
                                  }
                                },
                                [
                                  _c("div", {
                                    staticClass: "my-4",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.currentVariation.texts.technicalData
                                      )
                                    }
                                  })
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "tab-pane overflow-auto",
                              class: {
                                active:
                                  !_vm.isDescriptionTabActive &&
                                  !_vm.isTechnicalDataTabActive
                              },
                              attrs: {
                                id: "assessments-details",
                                role: "tabpanel"
                              }
                            },
                            [
                              _c("div", { staticClass: "my-4" }, [
                                _c(
                                  "table",
                                  {
                                    staticClass:
                                      "table table-striped table-hover table-sm"
                                  },
                                  [
                                    _c("tbody", [
                                      _vm.itemConfig.includes("item.id") ||
                                      _vm.itemConfig.includes("all")
                                        ? _c("tr", [
                                            _c("td", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$translate(
                                                    "Ceres::Template.singleItemId"
                                                  )
                                                )
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("td", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.currentVariation.item.id
                                                )
                                              )
                                            ])
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.currentVariation.item.condition &&
                                      _vm.currentVariation.item.condition.names
                                        .name !== "" &&
                                      (_vm.itemConfig.includes(
                                        "item.condition"
                                      ) ||
                                        _vm.itemConfig.includes("all"))
                                        ? _c("tr", [
                                            _c("td", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$translate(
                                                    "Ceres::Template.singleItemCondition"
                                                  )
                                                )
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("td", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.currentVariation.item
                                                    .condition.names.name
                                                )
                                              )
                                            ])
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.itemConfig.includes(
                                        "item.age_rating"
                                      ) || _vm.itemConfig.includes("all")
                                        ? _c("tr", [
                                            _c("td", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$translate(
                                                    "Ceres::Template.singleItemAge"
                                                  )
                                                )
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("td", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("ageRestriction")(
                                                    _vm.currentVariation.item
                                                      .ageRestriction
                                                  )
                                                )
                                              )
                                            ])
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.currentVariation.variation
                                        .externalId !== "" &&
                                      (_vm.itemConfig.includes(
                                        "item.external_id"
                                      ) ||
                                        _vm.itemConfig.includes("all"))
                                        ? _c("tr", [
                                            _c("td", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$translate(
                                                    "Ceres::Template.singleItemExternalVariationId"
                                                  )
                                                )
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("td", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.currentVariation.variation
                                                    .externalId
                                                )
                                              )
                                            ])
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.currentVariation.variation.model !==
                                        "" &&
                                      (_vm.itemConfig.includes(
                                        "item.variation_model"
                                      ) ||
                                        _vm.itemConfig.includes("all"))
                                        ? _c("tr", [
                                            _c("td", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$translate(
                                                    "Ceres::Template.singleItemModel"
                                                  )
                                                )
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("td", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.currentVariation.variation
                                                    .model
                                                )
                                              )
                                            ])
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.currentVariation.filter
                                        .hasManufacturer &&
                                      _vm.currentVariation.item.manufacturer
                                        .externalName !== "" &&
                                      (_vm.itemConfig.includes(
                                        "item.manufacturer"
                                      ) ||
                                        _vm.itemConfig.includes("all"))
                                        ? _c("tr", [
                                            _c("td", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$translate(
                                                    "Ceres::Template.singleItemManufacturer"
                                                  )
                                                )
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("td", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.currentVariation.item
                                                    .manufacturer.externalName
                                                )
                                              )
                                            ])
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.currentVariation.item
                                        .producingCountry &&
                                      _vm.currentVariation.item.producingCountry
                                        .names.name !== "" &&
                                      (_vm.itemConfig.includes(
                                        "item.producerCountry"
                                      ) ||
                                        _vm.itemConfig.includes("all"))
                                        ? _c("tr", [
                                            _c("td", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$translate(
                                                    "Ceres::Template.singleItemManufacturingCountry"
                                                  )
                                                )
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("td", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.currentVariation.item
                                                    .producingCountry.names.name
                                                )
                                              )
                                            ])
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.currentVariation.unit &&
                                      (_vm.itemConfig.includes(
                                        "item.variationBase_content"
                                      ) ||
                                        _vm.itemConfig.includes("all"))
                                        ? _c("tr", [
                                            _c("td", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$translate(
                                                    "Ceres::Template.singleItemContent"
                                                  )
                                                )
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("td", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.currentVariation.unit
                                                    .content
                                                ) +
                                                  " " +
                                                  _vm._s(
                                                    _vm.currentVariation.unit
                                                      .names.name
                                                  )
                                              )
                                            ])
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.currentVariation.variation.weightG !==
                                        "" &&
                                      (_vm.itemConfig.includes(
                                        "item.weightG"
                                      ) ||
                                        _vm.itemConfig.includes("all"))
                                        ? _c("tr", [
                                            _c("td", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$translate(
                                                    "Ceres::Template.singleItemWeight"
                                                  )
                                                )
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("td", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.currentVariation.variation
                                                    .weightG
                                                ) + " g"
                                              )
                                            ])
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.currentVariation.variation
                                        .weightNetG !== "" &&
                                      (_vm.itemConfig.includes(
                                        "item.weightNetG"
                                      ) ||
                                        _vm.itemConfig.includes("all"))
                                        ? _c("tr", [
                                            _c("td", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$translate(
                                                    "Ceres::Template.singleItemNetWeight"
                                                  )
                                                )
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("td", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.currentVariation.variation
                                                    .weightNetG
                                                ) + " g"
                                              )
                                            ])
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.itemConfig.includes(
                                        "item.variation_dimensions"
                                      ) || _vm.itemConfig.includes("all")
                                        ? _c("tr", [
                                            _c("td", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$translate(
                                                    "Ceres::Template.singleItemDimensions"
                                                  )
                                                )
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("td", [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.currentVariation
                                                      .variation.lengthMM
                                                  )
                                                )
                                              ]),
                                              _vm._v("×"),
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.currentVariation
                                                      .variation.widthMM
                                                  )
                                                )
                                              ]),
                                              _vm._v("×"),
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.currentVariation
                                                      .variation.heightMM
                                                  )
                                                )
                                              ]),
                                              _vm._v(
                                                " mm\n                                                "
                                              )
                                            ])
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.currentVariation.variation
                                        .customsTariffNumber !== "" &&
                                      (_vm.itemConfig.includes(
                                        "variation.customs_tariff_number"
                                      ) ||
                                        _vm.itemConfig.includes("all"))
                                        ? _c("tr", [
                                            _c("td", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$translate(
                                                    "Ceres::Template.singleItemCustomsTariffNumber"
                                                  )
                                                )
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("td", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.currentVariation.variation
                                                    .customsTariffNumber
                                                )
                                              )
                                            ])
                                          ])
                                        : _vm._e()
                                    ])
                                  ]
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _vm._t("add-detail-tabs-content")
                        ],
                        2
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _vm._t("item-list-container"),
                _vm._v(" "),
                _vm._t("feedback-container")
              ],
              2
            )
          ]
        },
        {
          getDataField: _vm.getDataField,
          getFilteredDataField: _vm.getFilteredDataField
        }
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }